import React, { Component, createRef } from "react";
import "component/game/GameItemBanner/styles.scss";
import defaultBanner from "assets/images/bannerDefault.png";
import { ReactComponent as Play } from "assets/icons/Play-Launch.svg";
import { ReactComponent as PlayDemo } from "assets/icons/play-demo.svg";
import { setDefaultImageFormat } from "utils/image";
import { getTotalPool } from "utils/getTotalpool";
import { currencyFormatter } from "utils/currencyHelper";
import { is } from "immutable";
import { withNamespaces } from "react-i18next";
import { isEqual } from "lodash";

class GameItemBanner extends Component {
  constructor(props) {
    super(props);
    this.loadGame = this._loadGame.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    this.bannerContainer = createRef();
    this.checkRatio = this._checkRatio.bind(this);
    this.getCurrentJackpotPool = this._getCurrentJackpotPool.bind(this);
    this.state = {
      game: null,
      bannerUrl: null,
      isLoading: true,
      linkReal: null,
      linkDemo: null,
      fullWidth: true,
    };
  }

  _getCurrentJackpotPool() {
    const { game, jackpotMemoryCache } = this.props;
    const targetGame = this.state.game || game;
    if (!targetGame) return null;

    const groupId = targetGame.get("jackpotGroupId");

    if (jackpotMemoryCache && groupId && jackpotMemoryCache[groupId]) {
      return jackpotMemoryCache[groupId];
    }

    let defaultPool = null;
    let existingJackpotBalance = targetGame.get("jackpotBalance");

    if (existingJackpotBalance !== undefined && existingJackpotBalance !== null) {
      defaultPool = {
        default: { amount: existingJackpotBalance },
      };
    }

    return defaultPool;
  }

  _loadGame(game) {
    this.setState({
      game: null,
      bannerUrl: null,
      isLoading: true,
      linkReal: null,
      linkDemo: null,
    });

    let newGame = game;

    if (newGame.get("playType") === "game.details") {
      newGame = newGame.set("playType", "launch.real");
    }

    this.props
      .fetchGame(newGame)
      .then((resp) => {
        this.setState({
          game: resp.payload,
        });
        return resp;
      })
      .then((resp) => {
        let linkDemo = resp.payload.get("links").find((link) => {
          return link.get("rel") === "launch.demo";
        });

        let linkReal = resp.payload.get("links").find((link) => {
          return link.get("rel") === "launch.real";
        });

        this.setState({
          bannerUrl: resp.payload.getIn(["images", "bannerUrl"]),
          linkDemo,
          linkReal,
        });
      });
  }

  componentDidMount() {
    this.initResizeObserver();
    if (this.props.game) {
      this.loadGame(this.props.game);
    }
  }

  componentWillUnmount() {
    this.resizeObserver.unobserve(this.bannerContainer.current);
  }

  initResizeObserver() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        this.checkRatio(width, height);
      }
    });
    this.resizeObserver.observe(this.bannerContainer.current);
  }

  componentWillReceiveProps(nextProps) {
    if (!is(nextProps.game, this.props.game) && nextProps.game) {
      this.loadGame(nextProps.game);
    }
  }

  _checkRatio(width, height) {
    const ratio = width / height;
    this.setState({
      fullWidth: ratio > 2 ? false : true,
    });
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.screen, this.props.screen)) {
      this.checkRatio();
    }

    if (!isEqual(prevProps.layout, this.props.layout)) {
      this.checkRatio();
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div
        className="game-item-banner d-flex justify-content-center align-items-center"
        ref={this.bannerContainer}
      >
        <div className="background-container">
          {!this.state.isLoading && (
            <>
              <div
                className="background"
                style={{
                  backgroundImage: `url(${setDefaultImageFormat(
                    this.state.bannerUrl + "width=800&theme=dark&",
                    this.props.imageFormat.get("banner"),
                  )})`,
                }}
              />
              <div className="background-gradient-overlay" />
            </>
          )}
        </div>
        {this.state.isLoading && (
          <div
            className="background"
            style={{
              backgroundImage: `url(${defaultBanner})`,
            }}
          />
        )}

        <div
          className={`banner-container d-flex justify-content-center align-items-center ${
            this.state.fullWidth ? "full-width" : "full-height"
          }`}
        >
          {this.state.bannerUrl && (
            <img
              className={this.state.isLoading ? "d-none" : ""}
              src={`${setDefaultImageFormat(
                this.state.bannerUrl + "&width=1000&theme=dark&",
                this.props.imageFormat.get("banner"),
              )}`}
              alt="banner"
              onLoad={() => {
                this.setState({
                  isLoading: false,
                });
              }}
            />
          )}
          {this.state.isLoading && <img src={defaultBanner} alt="banner" />}

          {this.state.game &&
            this.state.game.get("gameLimit") &&
            this.state.game.get("gameLimit").get('minBet') && (
              <div className="game-limits">
                <span className="min-bet">
                  {currencyFormatter(
                    this.state.game.getIn(["gameLimit", "minBet"]),
                    {
                      symbol: this.props.symbol,
                      currency: this.props.currency,
                      dropZeroDecimals: true,
                    },
                  )}
                </span>
                <span className="max-bet">
                  {` - ${currencyFormatter(
                    this.state.game.getIn(["gameLimit", "maxBet"]),
                    { dropZeroDecimals: true },
                  )}`}
                </span>
              </div>
            )}

          {this.state.game && (
            <div className="jackpot-amount">
              {this.getTotalPool(
                this.getCurrentJackpotPool(),
                this.state.game,
                false,
              )}
            </div>
          )}

          {(this.state.linkReal || this.state.linkDemo) && (
            <div className="button-group-container">
              <div className="gradient-overlay" />
              <div className="button-group">
                {this.state.linkReal && (
                  <button
                    className="btn btn-danger w-100"
                    onClick={(event) => {
                      let gameId = this.state.game.get("gameId");
                      let playType = this.state.linkReal.get("rel");
                      let nav = this.state.game.get("nav");

                      let gameParams = {
                        gameId,
                        playType,
                        nav,
                      };

                      let currentPool = this.getCurrentJackpotPool();
                      if (currentPool) {
                        let total = 0;
                        Object.values(currentPool).forEach((val) => {
                          if (val && !isNaN(Number(val.amount))) {
                            total += Number(val.amount);
                          }
                        });

                        if (total > 0) {
                          gameParams.jackpotBalance = total;
                          gameParams.balance = total;
                        } else {
                          gameParams.jackpotBalance = this.state.game.get(
                            "jackpotBalance",
                          );
                          gameParams.balance = this.state.game.get("balance");
                        }
                      } else {
                        gameParams.jackpotBalance = this.state.game.get(
                          "jackpotBalance",
                        );
                        gameParams.balance = this.state.game.get("balance");
                      }

                      this.props.onGameItemClickHandler(gameParams);
                      event.stopPropagation();
                    }}
                  >
                    <span className="play-now-icon">
                      <Play />
                    </span>
                    &nbsp;
                    {t("playNow")}
                  </button>
                )}
                {this.state.linkDemo && (
                  <button
                    className="btn btn-secondary w-100"
                    onClick={(event) => {
                      let gameId = this.state.game.get("gameId");
                      let playType = this.state.linkDemo.get("rel");

                      let gameParams = {
                        gameId,
                        playType,
                      };

                      let currentPool = this.getCurrentJackpotPool();
                      if (currentPool) {
                        let total = 0;
                        Object.values(currentPool).forEach((val) => {
                          if (val && !isNaN(Number(val.amount))) {
                            total += Number(val.amount);
                          }
                        });

                        if (total > 0) {
                          gameParams.jackpotBalance = total;
                          gameParams.balance = total;
                        } else {
                          gameParams.jackpotBalance = this.state.game.get(
                            "jackpotBalance",
                          );
                          gameParams.balance = this.state.game.get("balance");
                        }
                      } else {
                        gameParams.jackpotBalance = this.state.game.get(
                          "jackpotBalance",
                        );
                        gameParams.balance = this.state.game.get("balance");
                      }

                      this.props.onGameItemClickHandler(gameParams);
                      event.stopPropagation();
                    }}
                  >
                    <span className="play-now-icon">
                      <PlayDemo />
                    </span>
                    &nbsp;{t("demoPlay")}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withNamespaces("translation")(GameItemBanner);
